<script>
import { get } from 'vuex-pathify'

let activeMenuVm = null
let sharedLeaveTimer = null
const MENU_SWITCH_GRACE_MS = 180

export default {
	props: {
		text: String,
		link: String,
		buttonProps: Object,
		submenuStyle: [Object, String],
		transparent: Boolean,
		widthStyle: Object,
	},
	data() {
		return {
			open: false,
			maxHeight: null,
			scrollHandler: null,
		}
	},
	computed: {
		routeLoading: get('shop/routeLoading'),
	},
	methods: {
		openMenu() {
			clearTimeout(sharedLeaveTimer)

			if (activeMenuVm && activeMenuVm !== this) {
				activeMenuVm.open = false
			}

			activeMenuVm = this
			this.open = true
		},
		scheduleClose() {
			clearTimeout(sharedLeaveTimer)
			sharedLeaveTimer = setTimeout(() => {
				if (activeMenuVm !== this) return
				this.open = false
				activeMenuVm = null
			}, MENU_SWITCH_GRACE_MS)
		},
		onActivatorClick() {
			if (this.open) {
				this.open = false
				if (activeMenuVm === this) activeMenuVm = null
				return
			}

			this.openMenu()
		},
		setSubmenuMaxHeight() {
			const appbarBottom = this.$refs['activator-wrapper|']?.getBoundingClientRect().bottom
			if (!appbarBottom) return
			const height = window.innerHeight - appbarBottom
			const appbarMenuOffset = 80
			this.maxHeight = height - appbarMenuOffset
		},
	},
	watch: {
		routeLoading() {
			this.open = false
			if (activeMenuVm === this) activeMenuVm = null
		},
	},
	mounted() {
		this.scrollHandler = () => {
			this.open = false
			if (activeMenuVm === this) activeMenuVm = null
		}

		document.addEventListener('scroll', this.scrollHandler)

		this.setSubmenuMaxHeight()
	},
	beforeDestroy() {
		if (activeMenuVm === this) activeMenuVm = null
		clearTimeout(sharedLeaveTimer)
		document.removeEventListener('scroll', this.scrollHandler)
	},
}
</script>

<template>
	<div ref="activator-wrapper" @mouseenter="openMenu" @mouseleave="scheduleClose">
		<!-- Activator -->
		<SafeLink :to="link">
			<div class="d-flex h100">
				<AppBar-Button :transparent="transparent" class="primary" v-bind="buttonProps" />
			</div>
		</SafeLink>

		<!-- Menu -->
		<transition name="submenu-fade">
			<div
				v-if="open"
				class="submenu pa-6"
				:style="[{ 'max-height': `${maxHeight}px!important` }, submenuStyle, widthStyle]"
			>
				<slot></slot>
			</div>
		</transition>
	</div>
</template>

<style scoped lang="scss">
.submenu-fade-enter-active,
.submenu-fade-leave-active {
	transition: opacity 0.3s ease;
}

.submenu-fade-enter,
.submenu-fade-leave-to {
	opacity: 0;
}

.activator-wrapper {
	position: relative;
}

.submenu {
	position: absolute;
	top: 100%;
	left: 0;
	width: 100%;
	min-height: 350px;
	overflow: auto;
	background-color: var(--secondary);
	z-index: 3;

	&::-webkit-scrollbar {
		width: 3px;
	}

	&::-webkit-scrollbar-track {
		box-shadow: inset 0 0 6px rgba(145, 144, 144, 0.3);
	}

	&::-webkit-scrollbar-thumb {
		background-color: var(--base);
		outline: 1px solid rgb(143, 143, 144);
	}
}
</style>

